import React, { useState } from 'react'
import { HamburgerButton, Menu } from '@accodeing/gatsby-theme-heimr'
import { Link } from 'gatsby'

import logotype from 'images/logo.svg'

const Header = () => {
  const [menuOpen, setMenuOpened] = useState(false)

  return (
    <oma-grid-row contentAlignedWithGrid fullWidth class='row'>
      <header className='header'>
        <div className='header__content'>
          <Link to='/'>
            <img
              className='header__logotype'
              src={logotype}
              alt='ECO VS logotype'
            />
          </Link>
          <div className='menu-container'>
            <HamburgerButton
              open={menuOpen}
              onOpen={() => setMenuOpened(true)}
              onClose={() => setMenuOpened(false)}
            />
            <Menu
              onClose={() => setMenuOpened(false)}
              onNavigation={() => setMenuOpened(false)}
              onOpen={() => setMenuOpened(true)}
              open={menuOpen}
            />
          </div>
        </div>
      </header>
    </oma-grid-row>
  )
}

export default Header
